import { CheckOutlined } from '@ant-design/icons';
import { styleVariables } from '@lib/common';
import { SubmissionScore } from '@module/assignment';
import { QuestionType } from '@module/form';
import { Skeleton, Space } from 'antd';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var AnnotationType;

(function (AnnotationType) {
  AnnotationType[AnnotationType["Skipped"] = 0] = "Skipped";
  AnnotationType[AnnotationType["FillInBlankOrEssay"] = 1] = "FillInBlankOrEssay";
  AnnotationType[AnnotationType["Correct"] = 2] = "Correct";
  AnnotationType[AnnotationType["Incorrect"] = 3] = "Incorrect";
})(AnnotationType || (AnnotationType = {}));

var QuestionSummariesContainer = styled(Space).withConfig({
  displayName: "answer-summariescomponent__QuestionSummariesContainer",
  componentId: "sc-azmb1x-0"
})(["width:100%;.ant-space-item{width:19%;}"]);
var QuestionSummaryItem = styled.div.withConfig({
  displayName: "answer-summariescomponent__QuestionSummaryItem",
  componentId: "sc-azmb1x-1"
})(["--background-color:", ";--accent-color:", ";background:var(--background-color);color:var(--accent-color);border-radius:8px;border:2px solid ", ";position:relative;transition:border 150ms ease-out;cursor:pointer;padding-block:8px;&:hover{opacity:0.6;}"], function (props) {
  var isNotAnswered = props.isNotAnswered,
      isEssayOrFillInBlank = props.isEssayOrFillInBlank,
      isCorrect = props.isCorrect;

  if (isNotAnswered) {
    return styleVariables.colors.red5;
  }

  if (isEssayOrFillInBlank) {
    return styleVariables.colors.blue1;
  }

  if (isCorrect) {
    return styleVariables.colors.green2;
  }

  return styleVariables.colors.red5;
}, function (props) {
  var isNotAnswered = props.isNotAnswered,
      isEssayOrFillInBlank = props.isEssayOrFillInBlank,
      isCorrect = props.isCorrect;

  if (isNotAnswered) {
    return styleVariables.colors.red3;
  }

  if (isEssayOrFillInBlank) {
    return styleVariables.colors.blue2;
  }

  if (isCorrect) {
    return styleVariables.colors.green1;
  }

  return styleVariables.colors.red3;
}, function (props) {
  var active = props.active,
      theme = props.theme;

  if (active && !theme.media.isMobile) {
    return 'var(--accent-color)';
  }

  return 'transparent';
});
var QuestionIndex = styled.div.withConfig({
  displayName: "answer-summariescomponent__QuestionIndex",
  componentId: "sc-azmb1x-2"
})(["width:100%;height:100%;display:flex;align-items:center;justify-content:center;"]);
var QuestionIndexNumber = styled.label.withConfig({
  displayName: "answer-summariescomponent__QuestionIndexNumber",
  componentId: "sc-azmb1x-3"
})(["font-size:16px;font-weight:600;cursor:pointer;"]);
var StyledCheckIcon = styled(CheckOutlined).withConfig({
  displayName: "answer-summariescomponent__StyledCheckIcon",
  componentId: "sc-azmb1x-4"
})(["color:white;"]);
var StyledCheckIconContainer = styled.div.withConfig({
  displayName: "answer-summariescomponent__StyledCheckIconContainer",
  componentId: "sc-azmb1x-5"
})(["position:absolute;right:", ";bottom:", ";border-top-left-radius:8px;border-bottom-right-radius:7px;background-color:", ";width:24px;height:24px;display:flex;justify-content:center;align-items:center;"], function (props) {
  return props.active ? '0' : '-1.5px';
}, function (props) {
  return props.active ? '-0.5px' : '-1.5px';
}, styleVariables.colors.blue2);
export var GradingAnswerSummaries = function GradingAnswerSummaries(props) {
  var questions = props.questions,
      isLoadingQuestions = props.isLoadingQuestions,
      onSelectQuestion = props.onSelectQuestion,
      activeIndex = props.activeIndex,
      answers = props.answers;

  var isSingleChoiceAnswerCorrect = function isSingleChoiceAnswerCorrect(singleChoiceQuestion, singleChoiceAnswer) {
    return singleChoiceQuestion.correctAnswers.some(function (c) {
      var _singleChoiceAnswer$v;

      return c.answerId === ((_singleChoiceAnswer$v = singleChoiceAnswer.value) === null || _singleChoiceAnswer$v === void 0 ? void 0 : _singleChoiceAnswer$v.answerId);
    });
  };

  var isMultipleChoiceAnswerCorrect = function isMultipleChoiceAnswerCorrect(multipleChoiceQuestion, multipleChoiceAnswer) {
    var isAnswerValuesLengthEqualWithCorrectAnswerLength = multipleChoiceAnswer.values.length === multipleChoiceQuestion.correctAnswers.length;
    var isAllCorrectAnswers = multipleChoiceAnswer.values.every(function (a) {
      var hasContainedAnswer = multipleChoiceQuestion.correctAnswers.some(function (c) {
        return c.answerId === a.answerId;
      });
      return hasContainedAnswer;
    });
    return isAnswerValuesLengthEqualWithCorrectAnswerLength && isAllCorrectAnswers;
  };

  var renderQuestionSummaryItem = function renderQuestionSummaryItem(annotation, index, questionId, sectionId, isGraded) {
    switch (annotation) {
      case AnnotationType.Skipped:
        {
          return /*#__PURE__*/_jsxs(QuestionSummaryItem, {
            onClick: function onClick() {
              return onSelectQuestion(index, questionId, sectionId);
            },
            isNotAnswered: true,
            active: index === activeIndex,
            children: [/*#__PURE__*/_jsx(QuestionIndex, {
              children: /*#__PURE__*/_jsx(QuestionIndexNumber, {
                children: index + 1
              })
            }), isGraded && /*#__PURE__*/_jsx(StyledCheckIconContainer, {
              active: index === activeIndex,
              children: /*#__PURE__*/_jsx(StyledCheckIcon, {})
            })]
          }, index);
        }

      case AnnotationType.FillInBlankOrEssay:
        {
          return /*#__PURE__*/_jsxs(QuestionSummaryItem, {
            onClick: function onClick() {
              return onSelectQuestion(index, questionId, sectionId);
            },
            isEssayOrFillInBlank: true,
            active: index === activeIndex,
            children: [/*#__PURE__*/_jsx(QuestionIndex, {
              children: /*#__PURE__*/_jsx(QuestionIndexNumber, {
                children: index + 1
              })
            }), isGraded && /*#__PURE__*/_jsx(StyledCheckIconContainer, {
              active: index === activeIndex,
              children: /*#__PURE__*/_jsx(StyledCheckIcon, {})
            })]
          }, index);
        }

      case AnnotationType.Correct:
        {
          return /*#__PURE__*/_jsxs(QuestionSummaryItem, {
            onClick: function onClick() {
              return onSelectQuestion(index, questionId, sectionId);
            },
            isCorrect: true,
            active: index === activeIndex,
            children: [/*#__PURE__*/_jsx(QuestionIndex, {
              children: /*#__PURE__*/_jsx(QuestionIndexNumber, {
                children: index + 1
              })
            }), isGraded && /*#__PURE__*/_jsx(StyledCheckIconContainer, {
              active: index === activeIndex,
              children: /*#__PURE__*/_jsx(StyledCheckIcon, {})
            })]
          }, index);
        }

      case AnnotationType.Incorrect:
        {
          return /*#__PURE__*/_jsxs(QuestionSummaryItem, {
            onClick: function onClick() {
              return onSelectQuestion(index, questionId, sectionId);
            },
            active: index === activeIndex,
            children: [/*#__PURE__*/_jsx(QuestionIndex, {
              children: /*#__PURE__*/_jsx(QuestionIndexNumber, {
                children: index + 1
              })
            }), isGraded && /*#__PURE__*/_jsx(StyledCheckIconContainer, {
              active: index === activeIndex,
              children: /*#__PURE__*/_jsx(StyledCheckIcon, {})
            })]
          }, index);
        }
    }
  };

  var renderSummaries = function renderSummaries() {
    if (isLoadingQuestions) return /*#__PURE__*/_jsx(Skeleton, {});
    return questions.map(function (question, index) {
      var matchedAnswer = answers.find(function (answer) {
        return answer.questionId === question.id.toString();
      });

      switch (question.type) {
        case QuestionType.SingleChoice:
          {
            var singleChoiceQuestion = question;
            var singleChoiceAnswer = matchedAnswer;
            var questionType = AnnotationType.Incorrect;
            var isGraded = singleChoiceAnswer.score !== SubmissionScore["default"].value;
            var isAnswerValueEmpty = !singleChoiceAnswer.value;

            if (isAnswerValueEmpty) {
              questionType = AnnotationType.Skipped;
            }

            if (isSingleChoiceAnswerCorrect(singleChoiceQuestion, singleChoiceAnswer)) {
              questionType = AnnotationType.Correct;
            }

            return renderQuestionSummaryItem(questionType, index, question.id.toString(), question.sectionId, isGraded);
          }

        case QuestionType.MultipleChoice:
          {
            var multipleChoiceQuestion = question;
            var multipleChoiceAnswers = matchedAnswer;
            var _questionType = AnnotationType.Incorrect;

            var _isGraded = multipleChoiceAnswers.score !== SubmissionScore["default"].value;

            var _isAnswerValueEmpty = !multipleChoiceAnswers.values || multipleChoiceAnswers.values.length === 0;

            if (_isAnswerValueEmpty) {
              _questionType = AnnotationType.Skipped;
            }

            if (isMultipleChoiceAnswerCorrect(multipleChoiceQuestion, multipleChoiceAnswers)) {
              _questionType = AnnotationType.Correct;
            }

            return renderQuestionSummaryItem(_questionType, index, question.id.toString(), question.sectionId, _isGraded);
          }

        case QuestionType.Essay:
          {
            var essayAnswer = matchedAnswer;
            var _questionType2 = AnnotationType.FillInBlankOrEssay;

            var _isGraded2 = essayAnswer.score !== SubmissionScore["default"].value;

            var _isAnswerValueEmpty2 = !essayAnswer.value;

            if (_isAnswerValueEmpty2) {
              _questionType2 = AnnotationType.Skipped;
            }

            return renderQuestionSummaryItem(_questionType2, index, question.id.toString(), question.sectionId, _isGraded2);
          }

        case QuestionType.FillInBlank:
          {
            var fillInBlankAnswer = matchedAnswer;
            var _questionType3 = AnnotationType.FillInBlankOrEssay;

            var _isGraded3 = fillInBlankAnswer.answers.every(function (a) {
              return a.score !== SubmissionScore["default"].value;
            });

            var _isAnswerValueEmpty3 = fillInBlankAnswer.answers.every(function (a) {
              return !a.value;
            });

            if (_isAnswerValueEmpty3) {
              _questionType3 = AnnotationType.Skipped;
            }

            return renderQuestionSummaryItem(_questionType3, index, question.id.toString(), question.sectionId, _isGraded3);
          }
      }
    });
  };

  return /*#__PURE__*/_jsx(QuestionSummariesContainer, {
    wrap: true,
    children: renderSummaries()
  });
};